import { Stack } from '@mui/material';
import { WsTypography, WsTypoColors, WsTypoVariants } from 'wisestep-base';

import { extractContent } from '../../SentEmailLogs';
import { singleDataType } from '../helper';

export const ToFormField = (handleContent: singleDataType) => {
  const toList = `${extractContent(handleContent.content?.to).toString()}`
    .split(',')
    .filter((email) => email != handleContent.content.recruiterId)
    .join();

  return handleContent.content ? (
    <Stack direction={'row'} justifyContent={'flex-start'} sx={{ pt: 1, pb: 1 }}>
      <WsTypography color={WsTypoColors.PRIMARY} variant={WsTypoVariants.BODY1}>
        To : {handleContent.content.recruiterName}({handleContent.content.recruiterId}),
        {toList}...
      </WsTypography>
    </Stack>
  ) : (
    <></>
  );
};
